import { useQuery } from '@tanstack/react-query'
import { PersonIdentity, type PersonIdentityData } from '@/components/person-identity'
import { studentApi } from '@/modules/students/students.service'
import { teacherApi } from '@/modules/teachers/teachers.service'
import { contactApi } from '@/modules/contacts/contacts.api'
import type { ReactNode } from 'react'
import { HugeiconsIcon } from '@hugeicons/react'
import { UserIcon } from '@hugeicons/core-free-icons'
import { Badge } from '@/components/ui/badge'
import { Button } from '@/components/ui/button'
import { Label } from '@/components/ui/label'
import { RECIPIENT_TYPE_LABELS } from '../whatsapp.types'
import { RecipientCombobox, type RecipientOption } from './recipient-combobox'

export function MessageRecipientField({
  recipient,
  locked,
  onClear,
  onSelect,
  children,
}: {
  recipient: RecipientOption | null
  locked: boolean
  onClear: () => void
  onSelect: (recipient: RecipientOption) => void
  children: ReactNode
}) {
  const { data: person } = useQuery<PersonIdentityData>({
    queryKey: [recipient?.type === 'guardian' ? 'contact' : recipient?.type, recipient?.id],
    queryFn: () => recipient!.type === 'student' ? studentApi.getById(recipient!.id)
      : recipient!.type === 'teacher' ? teacherApi.getById(recipient!.id)
      : contactApi.get(recipient!.id),
    enabled: !!recipient?.id && (recipient.gender === undefined || recipient.dateOfBirth === undefined),
  })
  return (
    <div className="flex flex-col gap-2">
      <Label className="flex items-center gap-1.5">
        <HugeiconsIcon
          icon={UserIcon}
          className="size-4 text-muted-foreground"
        />
        Para
      </Label>
      {recipient ? (
        <div className="flex items-center gap-3 rounded-2xl border bg-card p-3">
          <div className="flex min-w-0 flex-1 flex-col gap-2">
            <div className="flex items-start gap-2">
              <PersonIdentity person={person ?? recipient} />
              <Badge variant="secondary" className="shrink-0">
                {RECIPIENT_TYPE_LABELS[recipient.type]}
              </Badge>
            </div>
            {children}
          </div>
          {!locked && (
            <Button
              type="button"
              variant="outline"
              size="sm"
              className="shrink-0"
              onClick={onClear}
            >
              Cambiar
            </Button>
          )}
        </div>
      ) : (
        <RecipientCombobox onChange={onSelect} />
      )}
    </div>
  )
}
